import { useState, useContext, useEffect } from "react"
import { Button, Card, Col, Form, Row, OverlayTrigger, Tooltip, Modal } from "react-bootstrap"
import { BsPlusCircleFill } from "react-icons/bs"
import { HiOutlineTrash } from "react-icons/hi"
import { Field, Formik } from "formik"
import Select from 'react-select';
import * as Yup from 'yup';
import { useHistory } from "react-router-dom"

import Get from '../../api/Get'
import Post from '../../api/Post'
import Put from '../../api/Put'
import {
    ESPECIALITIES_ALL,
    DOCTOR_GET,
    DOCTOR_ADD,
    DOCTOR_UPDATE,
    TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
    PROVIDER_LIST_ACTIVE,
    LANGUAGE_ACTIVE_ALL,
    // CONSULTORIO_MODALIDADES,
    // VIDEOCONSULTA_MODALIDADES
} from '../../api/Routes'
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import { UploadImage } from "./UploadImage"
import { withTranslation } from "react-i18next"
import { isBase64 } from "../../utils/isBase64"

import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import 'react-phone-input-2/lib/style.css'
import { toast } from "react-toastify"
import moment from "moment"
import DatePicker, { registerLocale } from 'react-datepicker'
import esp from 'date-fns/locale/es';
import ComponentModalErrorSever from "../ComponentModalErrorSever"
import SelectEstado from "../SelectEstado"
registerLocale('es', esp)

function FormDoctorCLB({ t, id }) {
    const { auth } = useContext(authContext)
    const history = useHistory();
    const [gender, setGender] = useState('Female')
    const [loading, setLoading] = useState(false)
    const [licenceSpeciality, setLicenceSpeciality] = useState([])
    const [showModalEspeciality, setShowModalEspeciality] = useState(false)
    const [specialityOpt, setSpecialityOpt] = useState([])//Para la lista de selección
    const [phone, setPhone] = useState('')
    const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([])
    const [languageOpt, setLanguageOpt] = useState([])
    const [dateOfBirthday, setDateOfBirthday] = useState(null)
    const [providerOpt, setProviderOpt] = useState([])
    const [proveedorDefault, setProveedorDefault] = useState(null)
    // const [OnlineValues, setOnlineValues] = useState([])
    // const [ConsultorioValues, setConsultorioValues] = useState([])

    //server error
    const [show, setShow] = useState(false)
    const [error, setError] = useState(null)
    const handleClose = () => setShow(false)

    const [initialValues, setInitialValues] = useState({
        name: '',
        lastName: '',
        phone: '',
        email: '',
        gender: 'Female',
        licenceSpeciality: [],
        password: '',
        providerService: '',
        url_photo: '',
        url_signature: '',
        company: auth.data.company,
        identityDocumentType: '',
        documentNumber: '',
        language: '',
        dateOfBirthday: '',
        esConsultorio: false,
        // modalidades: []
    })

    const getTipoDocumento = (value) => {
        let arr = tipoDocumentoOpt.filter(el => el.code === "AS" || el.code === "MS").map(e => (e.id))
        return arr.includes(parseInt(value))
    }

    const shemaValidate = id ? Yup.object().shape({
        name: Yup.string().required(t('Camporequerido')),
        lastName: Yup.string().required(t('Camporequerido')),
        phone: Yup.string().required(t('Camporequerido')),
        email: Yup.string().required(t('Camporequerido')).email(t('Correoinvalido')),
        gender: Yup.string().required(t('Camporequerido')),
        providerService: Yup.string().required(t('Camporequerido')),
        identityDocumentType: Yup.string().required(t('Camporequerido')),
        language: Yup.string().required(t('Camporequerido')),
        documentNumber: Yup.string().when('identityDocumentType', {
            is: value => getTipoDocumento(value),
            then: Yup.string()
                .notRequired(),
            otherwise: Yup.string().required(t('Camporequerido')),
        }),
    }) : Yup.object().shape({
        name: Yup.string().required(t('Camporequerido')),
        lastName: Yup.string().required(t('Camporequerido')),
        phone: Yup.string().required(t('Camporequerido')),
        email: Yup.string().required(t('Camporequerido')).email(t('Correoinvalido')),
        gender: Yup.string().required(t('Camporequerido')),
        password: Yup.string().required(t('Camporequerido')),
        providerService: Yup.string().required(t('Camporequerido')),
        identityDocumentType: Yup.string().required(t('Camporequerido')),
        language: Yup.string().required(t('Camporequerido')),
        documentNumber: Yup.string().when('identityDocumentType', {
            is: value => getTipoDocumento(value),
            then: Yup.string()
                .notRequired(),
            otherwise: Yup.string().required(t('Camporequerido')),
        }),
    });

    const [speciality, setSpeciality] = useState({
        "idSpeciality": '',
        "speciality": '',
        "licence": '',
        "formationPlace": ''
    })

    const specialityValidate = Yup.object().shape({
        speciality: Yup.string().required('Campo Requerido'),
        licence: Yup.string().required('Campo Requerido')
    });


    const accesToken = auth.data.access_token

    //GEt Lista de especialidades
    useEffect(() => {
        Get({ url: ESPECIALITIES_ALL, access_token: accesToken })
            .then(resp => {
                let data = resp.data.data.response
                let opt = []
                data.map((d) => {
                    opt.push({ value: `${d.id}`, label: `${d.name}` })
                });
                setSpecialityOpt(opt)
            })
            .catch(error => {
                setShow(true)
                if (error.response) {
                    setError(error.response)
                }
            })
        // Get({ url: CONSULTORIO_MODALIDADES, access_token: accesToken })
        //     .then(resp => {
        //         let data = resp.data
        //         let mod = []
        //         data.map((d) => {
        //             mod.push({label: `${d.descripcion}`, value: `${d.id}`, shortLabel: `${d.clave}`})
        //         })
        //         setConsultorioValues(mod)
        //     })
        //     .catch(error => {
        //         setShow(true)
        //         if (error.response) {
        //             setError(error.response)
        //         }
        //     })
        // Get({ url: VIDEOCONSULTA_MODALIDADES, access_token: accesToken })
        //     .then(resp => {
        //         let data = resp.data
        //         let mod = []
        //         data.map((d) => {
        //             mod.push({label: `${d.descripcion}`, value: `${d.id}`, shortLabel: `${d.clave}`})
        //         })
        //         setOnlineValues(mod)
        //     })
        //     .catch(error => {
        //         setShow(true)
        //         if (error.response) {
        //             setError(error.response)
        //         }
        //     })
        Get({ url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, noToken: true })
            .then(response => {
                setTipoDocumentoOpt(response.data)
            })
            .catch(error => {
                setShow(true)
                if (error.response) {
                    setError(error.response)
                }
            })
        Get({ url: LANGUAGE_ACTIVE_ALL, access_token: auth.data.access_token })
            .then(response => {
                setLanguageOpt(response.data)
            })
            .catch(error => {
                setShow(true)
                if (error.response) {
                    setError(error.response)
                }
            })
        Get({ url: PROVIDER_LIST_ACTIVE, access_token: accesToken })
            .then(resp => {
                //console.log(resp)
                setProviderOpt(resp?.data.data.response.map(el => ({ value: el.id, label: el.name })))
            })
            .catch(error => {
                setShow(true)
                if (error.response) {
                    setError(error.response)
                }
            })
    }, [])

    //Para obtener la información del doctor
    useEffect(() => {
        if (id) {
            setLoading(true)

            Get({ url: `${DOCTOR_GET}/${id}`, access_token: accesToken })
                .then(resp => {
                    //console.log(resp)
                    let data = resp.data.data
                    let espDefault = []

                    data.licenceSpeciality.map(es => {
                        let def = specialityOpt.filter(opc => opc.value == es.idSpeciality)
                        espDefault.push(def[0])
                    })

                    setLicenceSpeciality(data?.licenceSpeciality ?? [])

                    let infoDoctor = {
                        name: data.name ?? '',
                        lastName: data.lastName ?? '',
                        phone: data.phone ?? '',
                        email: data.email ?? '',
                        gender: data.gender ?? 'Female',
                        licenceSpeciality: data.licenceSpeciality ?? [],
                        providerService: data?.providerService?.id ?? '',
                        url_photo: data.url_photo ? data.url_photo : '',
                        url_signature: data.url_signature ?? '',
                        identityDocumentType: data.identityDocumentType ? data.identityDocumentType.id : '',
                        documentNumber: data.documentNumber ? data.documentNumber : '',
                        language: data.language ? data.language.id : '',
                        dateOfBirthday: data.dateOfBirthday ? new Date(moment(data.dateOfBirthday, 'DD-MM-YYYY')) : '',
                        company: initialValues.company,
                        esConsultorio: data.esConsultorio,
                        // modalidades: data.modalidades
                    }
                    setPhone(data.phone)
                    setProveedorDefault({ value: data.providerService?.id, label: data.providerService?.name })
                    setGender(data?.gender ?? 'Female')
                    setInitialValues(infoDoctor)
                    setDateOfBirthday(data.dateOfBirthday ? new Date(moment(data.dateOfBirthday, 'DD-MM-YYYY')) : null)
                    setLoading(false)

                })
                .catch(error => {
                    setShow(true)
                    if (error.response) {
                        setError(error.response)
                    }
                    setLoading(false)
                })
        }
    }, [])

    //PAra generar la lista de obciones de las especialidades
    useEffect(() => {
        let opt = []

        specialityOpt.map((d) => {
            const enUso = licenceSpeciality.filter(l => l.idSpeciality == d.value)
            opt.push({
                value: `${d.value}`,
                label: `${d.label}`,
                isDisabled: enUso.length > 0
            })
        });
        setSpecialityOpt(opt)
    }, [licenceSpeciality])



    const handleShowModalEspeciality = () => setShowModalEspeciality(true)
    const handleCloseModalEspeciality = () => setShowModalEspeciality(false)

    const deleteEspecialidad = id => {
        const arr = licenceSpeciality.filter(item => item?.idSpeciality !== id)
        setLicenceSpeciality(arr)
    }



    return (<>
        {
            (id && loading) ? <LoadingList /> : <>

                <Formik initialValues={initialValues}
                    validationSchema={shemaValidate}
                    onSubmit={(values, { setSubmitting, setFieldValue }) => {
                        if (licenceSpeciality.length === 0) {
                            toast.warning('Es necesario seleccionar al menos una especialidad')
                            setSubmitting(false)
                            return
                        }

                        //console.log(values)

                        let data = Object.assign({}, values)

                        data.active = true
                        data.licenceSpeciality = licenceSpeciality
                        data.providerService = { id: parseInt(values.providerService) }
                        data.identityDocumentType = { id: values.identityDocumentType }
                        data.language = { id: values.language }
                        data.dateOfBirthday = values.dateOfBirthday ? moment(values.dateOfBirthday).format('DD-MM-YYYY') : null
                        // data.modalidades = data.modalidades.map(item => parseInt(item.value))

                        if (!isBase64(data.url_signature)) {
                            data.url_signature = ""
                        }
                        if (!isBase64(data.url_photo)) {
                            data.url_photo = ""
                        }
                        console.log(data)
                        if (id) {
                            data.id = parseInt(id)
                            Put({ url: DOCTOR_UPDATE, data: data, header: true, access_token: accesToken })
                                .then((resp) => {
                                    setSubmitting(false)
                                    history.goBack()
                                })
                                .catch((error) => {
                                    setSubmitting(false)
                                    setShow(true)
                                    if (error.response) {
                                        setError(error.response)
                                    }
                                })
                        } else {
                            Post({ url: DOCTOR_ADD, data: data, header: true, access_token: accesToken })
                                .then(resp => {
                                    setSubmitting(false)
                                    history.goBack()
                                })
                                .catch((error) => {
                                    setSubmitting(false)
                                    setShow(true)
                                    if (error.response) {
                                        setError(error.response)
                                    }
                                })
                        }
                    }}
                >{({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    setFieldError
                }) => (
                    <Form onSubmit={handleSubmit} className='mt-3'>
                        {isSubmitting && <LoadingList texto="Procesando petición" />}
                        <Row className="justify-content-md-center text-center">
                            <Col xs="6" md="6">
                                <UploadImage title='Foto'
                                    imageDefault={values?.url_photo}
                                    field='url_photo'
                                    setFieldValue={setFieldValue}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Card className="shadow-1">
                            <Card.Body>
                                <h4 className="text-color-4 subtitulo">Datos generales</h4>
                                <Row className='mt-5'>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Nombre <span className="text-danger">*</span></Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.name && 'error'}`}
                                                name="name"
                                            />
                                            {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Apellidos <span className="text-danger">*</span></Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.lastName && 'error'}`}
                                                name="lastName"
                                            />
                                            {errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Tipo documento <span className="text-danger">*</span></Form.Label>
                                            <Field
                                                as="select"
                                                className={`form-control input-form ${errors.identityDocumentType && 'error'}`}
                                                name="identityDocumentType"
                                            >
                                                <option value="">{t('Seleccionar')}</option>
                                                {
                                                    tipoDocumentoOpt.map((item, i) => (
                                                        <option value={item.id} key={i}>{`${item.code} : ${item.name}`}</option>
                                                    ))
                                                }
                                            </Field>
                                            {errors.identityDocumentType && <div className="invalid-feedback d-block">{errors.identityDocumentType}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Documento de identidad <span className="text-danger">*</span></Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.documentNumber && 'error'}`}
                                                name="documentNumber"
                                            />
                                            {errors.documentNumber && <div className="invalid-feedback d-block">{errors.documentNumber}</div>}
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xs="12" md="3">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Teléfono <span className="text-danger">*</span></Form.Label>
                                            <PhoneInput
                                                inputClass={`form-control input-form ${errors.phone && 'error'} w-100`}
                                                country={'co'}
                                                countryCodeEditable={false}
                                                enableSearch={true}
                                                preferredCountries={['co', 'mx']}
                                                disableSearchIcon={true}
                                                localization={es}
                                                value={phone}
                                                onChange={(ph, country, e, formattedValue) => {
                                                    setPhone(ph)
                                                    setFieldValue('phone', ph, false)
                                                    let validNumber = (country.format.match(/\./g)).length
                                                    if (ph.length !== validNumber) {
                                                        setFieldError('phone', 'Campo inválido')
                                                    } else if (ph.length === validNumber) {
                                                        setFieldValue('phone', ph, true)
                                                    }
                                                }}
                                            />
                                            {errors.phone && <div className="invalid-feedback d-block">{errors.phone}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="3">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Correo Electrónico <span className="text-danger">*</span></Form.Label>
                                            <Field
                                                type="email"
                                                className={`form-control input-form ${errors.email && 'error'}`}
                                                name="email"
                                            />
                                            {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">{t('compania')}</Form.Label>
                                            <input
                                                className="form-control input-form"
                                                defaultValue={auth.data.company.name}
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">{t('sexo')} <span className="text-danger">*</span></Form.Label>
                                            <ul className="mb-0 list-inline list-form">
                                                <li className={`${gender === 'Female' && 'active'} list-inline-item cursor-pointer`} onClick={e => {
                                                    setGender('Female')
                                                    setFieldValue('gender', 'Female')
                                                }}>
                                                    <span className="input-radio-custom text-color-input">Femenino</span>
                                                </li>
                                                <li className={`${gender === 'Male' && 'active'} list-inline-item cursor-pointer`} onClick={e => {
                                                    setGender('Male')
                                                    setFieldValue('gender', 'Male')
                                                }}>
                                                    <span className="input-radio-custom text-color-input">Masculino</span>
                                                </li>
                                                <li className={`${gender === 'NotSpecified' && 'active'} list-inline-item cursor-pointer`}
                                                    onClick={e => {
                                                        setGender('NotSpecified')
                                                        setFieldValue('gender', 'NotSpecified')
                                                    }}>
                                                    <span className="input-radio-custom text-color-input">No especificado</span>
                                                </li>
                                            </ul>
                                            {errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <div className="form-check form-check-inline">
                                            <Field
                                                className="form-check-input"
                                                name="esConsultorio"
                                                type="checkbox"
                                                onChange={(e) => {
                                                    setFieldValue('esConsultorio', e.target.checked);
                                                    // setFieldValue('modalidades', [])
                                                }}
                                            />
                                            <label className="form-check-label">Consultorio</label>
                                        </div>
                                        {/*<Form.Group>*/}
                                        {/*    <Form.Label className="font-weight-bold-600 text-secondary">Tipo de Modalidad <span className="text-danger">*</span></Form.Label>*/}
                                        {/*    <Select*/}
                                        {/*        options={values.esConsultorio ? ConsultorioValues : OnlineValues}*/}
                                        {/*        isMulti*/}
                                        {/*        value={values.modalidades}*/}
                                        {/*        onChange={(selected) => setFieldValue('modalidades', selected)}*/}
                                        {/*        formatOptionLabel={(option, { context }) => (*/}
                                        {/*            context === 'menu' ? option.label : option.shortLabel*/}
                                        {/*        )}*/}
                                        {/*        getOptionLabel={(option) => option.label} */}
                                        {/*        getOptionValue={(option) => option.value} */}
                                        {/*    />*/}
                                        {/*</Form.Group>*/}
                                    </Col>
                                </Row>
                                <Row>
                                    {!id && <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Password <span className="text-danger">*</span></Form.Label>
                                            <Field
                                                type="password"
                                                className={`form-control input-form ${errors.password && 'error'}`}
                                                name="password"
                                            />
                                            {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
                                        </Form.Group>
                                    </Col>}
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">Proveedor <span className="text-danger">*</span></Form.Label>
                                            <SelectEstado
                                                defaultValue={proveedorDefault}
                                                url={PROVIDER_LIST_ACTIVE}
                                                value={proveedorDefault}
                                                access_token={auth.data.access_token}
                                                isMulti={false}
                                                handleChange={(value) => {
                                                    setProveedorDefault(value)
                                                    setFieldValue("providerService", value.value)
                                                }}
                                                defaultOptions={providerOpt}
                                                valid={true}
                                                isClearable={false}
                                                className={`input-form ${errors.providerService && 'error'}`}
                                            />
                                            {errors.providerService && <div className="invalid-feedback d-block">{errors.providerService}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">{t('Idioma')} <span className="text-danger">*</span></Form.Label>
                                            <Field
                                                as="select"
                                                className={`form-control input-form ${errors.language && 'error'}`}
                                                name="language"
                                            >
                                                <option value="">{t('Seleccionar')}</option>
                                                {
                                                    languageOpt.map((item, i) => (
                                                        <option value={item.id} key={i}>{item.name}</option>
                                                    ))
                                                }
                                            </Field>
                                            {errors.language && <div className="invalid-feedback d-block">{errors.language}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary d-block">{t("fecha_nacimiento")}</Form.Label>
                                            <DatePicker
                                                locale="es"
                                                className={`form-control input-form w-100 ${errors.dateOfBirthday && 'error'}`}
                                                selected={dateOfBirthday}
                                                dateFormat="dd-MM-yyyy"
                                                maxDate={new Date()}
                                                onChange={date => {
                                                    if (date === null) {
                                                        setDateOfBirthday(null)
                                                        setFieldValue('dateOfBirthday', '')
                                                    } else {
                                                        setDateOfBirthday(date)
                                                        setFieldValue('dateOfBirthday', date)
                                                    }

                                                }} />
                                            {errors.dateOfBirthday && <div className="invalid-feedback d-block">{errors.dateOfBirthday}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                        <br />
                        <Row className="justify-content-md-center text-center">
                            <Col xs="6" md="6">
                                <UploadImage title='Firma'
                                    imageDefault={values?.url_signature}
                                    field='url_signature'
                                    setFieldValue={setFieldValue}
                                />
                                <span className="text-muted">Seleccionar la imagen con la orientación que se desea visualizar la firma</span>
                            </Col>
                        </Row>
                        <br />

                        <Card className="shadow-1 formSection">
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <h4 className="text-color-4 subtitulo">Datos de especialista</h4>
                                    </Col>
                                    <Col className="d-flex justify-content-end">
                                        <BsPlusCircleFill className="add-btn-middle clicked" onClick={handleShowModalEspeciality} />
                                    </Col>
                                </Row>
                                {
                                    licenceSpeciality.map((licence, l) => <Row key={licence?.idSpeciality}>
                                        <Col>{licence?.speciality}</Col>
                                        <Col>{licence?.licence}</Col>
                                        <Col>{licence?.formationPlace}</Col>
                                        <Col className="d-flex justify-content-end">
                                            <OverlayTrigger key={`EliminarEspecialidad${licence?.idSpeciality}`}
                                                placement='top'
                                                overlay={<Tooltip id={`eliminarEspecialidad${licence?.idSpeciality}`}> Eliminar especialidad </Tooltip>}
                                            >
                                                <HiOutlineTrash className='iconAction colorRojo clicked' onClick={() => deleteEspecialidad(licence?.idSpeciality)} />
                                            </OverlayTrigger>
                                        </Col>
                                    </Row>)
                                }
                            </Card.Body>
                        </Card>

                        <Row className="grupoBotones">
                            <Col className="text-right">
                                <Button variant="danger" className="cancelar-buttom" type="buttom" onClick={e => history.push('/admin/doctors')}>Cancelar</Button>{' '}
                                <Button variant="outline-success" className="ok-buttom" type="submit">{`${id ? 'Editar' : 'Agregar'}`}</Button>{' '}
                            </Col>
                        </Row>
                    </Form>
                )}
                </Formik>

                <Modal show={showModalEspeciality} onHide={handleCloseModalEspeciality} centered className="border-0" backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <Formik initialValues={speciality}
                            validationSchema={specialityValidate}
                            onSubmit={(values, { setSubmitting, setFieldValue }) => {

                                setLicenceSpeciality(l => [...l, values])
                                handleCloseModalEspeciality();

                            }}>{({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue
                            }) => (
                                <Form onSubmit={handleSubmit} className='mt-3'>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Especialidad</Form.Label>
                                                <Select
                                                    className="select-especialista"
                                                    closeMenuOnSelect={true}
                                                    options={specialityOpt}
                                                    onChange={item => {
                                                        setFieldValue('idSpeciality', item?.value)
                                                        setFieldValue('speciality', item?.label)
                                                    }}
                                                />
                                                {errors.speciality && <div className="invalid-feedback d-block">{errors.speciality}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Cédula profesional</Form.Label>
                                                <Field
                                                    type="text"
                                                    className={`form-control input-form ${errors.licence && 'error'}`}
                                                    name="licence"
                                                />
                                                {errors.licence && <div className="invalid-feedback d-block">{errors.licence}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Centro de estudios</Form.Label>
                                                <Field
                                                    type="text"
                                                    className={`form-control input-form ${errors.formationPlace && 'error'}`}
                                                    name="formationPlace"
                                                />
                                                {errors.formationPlace && <div className="invalid-feedback d-block">{errors.formationPlace}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <div className="text-right mt-4">
                                        <Button className="cancel-button px-4" variant="danger" type="submit">Agregar</Button>
                                        <Button variant="link" className="text-secondary no-underline" type="button" onClick={handleCloseModalEspeciality}>Cancelar</Button>
                                    </div>
                                </Form>
                            )}</Formik>
                    </Modal.Body>
                </Modal>
            </>
        }
        <ComponentModalErrorSever show={show} error={error} handleClose={handleClose} />
    </>)

}

export default withTranslation()(FormDoctorCLB)